<script>
export default {
  props: {
    news: {
      type: Object,
    },
  },
};
</script>

<template>
  <div>
    <router-link :to="{name: 'OrganizationView', params: {id: news.textParams[0]}}"
    >{{news.textParams[1]}}</router-link>
    {{$t('news.template.org.updateName.p1')}}
    "{{news.textParams[2]}}"
  </div>
</template>
